import { AxiosResponse } from 'axios';
import api from '../api';
import {
  IParentTimetableQueryParams,
  IParentTimetableResponse,
} from '../../interface/parentTimetable.interface';

// Parent (guardian) timetable endpoint (CVA-4740). The base URL already
// includes `/v2`; the call is JWT-authed and the server additionally resolves
// the guardian link for the `studentId` in the PATH — never one in the query.

const fetchParentTimetable = async (
  studentId: string,
  params?: IParentTimetableQueryParams,
): Promise<AxiosResponse<IParentTimetableResponse>> => {
  const response = await api.get<IParentTimetableResponse>(
    `/parent/timetable/student/${studentId}`,
    { params },
  );
  return response;
};

export const parentTimetableService = {
  fetchParentTimetable,
};
